import { ApexOptions } from "apexcharts";

export const donutChartData = {
    options: {
        chart: {
            type: 'pie',

        },
        labels: ['Active', 'Inactive', 'Pending', 'Acknowledged'],
        colors: ['#ff4560', '#00e396', '#0091ea', '#775dd0'],
        legend: {
            position: 'bottom',
        },
    } as ApexOptions,
};
